import {Loader} from "../../components/Loader/Loader";
import {useEffect} from "react";
import {connect} from "react-redux";
import {loadMobileBonusInfoAction} from "./mobileBonusActions";
import { createStructuredSelector } from "reselect";
import { getIsFirstLoginSelector } from "../../app/appSelectors";
import { setIsFirstLoginAction } from "../../app/appActions";

function MobileBonus(props) {
    const {isFirstLogin, loadMobileBonusInfoAction, setIsFirstLoginAction} = props;
    
    useEffect(() => {
        loadMobileBonusInfoAction();
    }, [loadMobileBonusInfoAction]);

    useEffect(() => () => {
        if (isFirstLogin) {
            setIsFirstLoginAction(false)
        }
    }, [isFirstLogin, setIsFirstLoginAction]);

    return (
            <Loader show/>
    )
}

const mapStateToProps = createStructuredSelector({
    isFirstLogin: getIsFirstLoginSelector,
});

const mapDispatchToProps = {
    loadMobileBonusInfoAction,
    setIsFirstLoginAction,
}

export default connect(mapStateToProps, mapDispatchToProps)(MobileBonus);
